import Drawer from "./Drawer";
import Icon from "./Icon";
import { fromNow } from "../utils/formatters";
import EmptyState from "./EmptyState";

export default function NotificationDrawer({ open, onClose, notifications, onMarkRead, onMarkAllRead }) {
  const list = notifications?.notifications?.data || [];
  const unread = notifications?.unread_count || 0;

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title="Notifications"
      subtitle={`${unread} unread`}
      footer={
        <button className="btn btn-secondary" onClick={onMarkAllRead} disabled={unread === 0}>
          Mark all read
        </button>
      }
    >
      {list.length === 0 ? (
        <EmptyState icon="bell" title="No notifications" hint="You're all caught up." />
      ) : (
        <div className="col gap-sm">
          {list.map((n) => (
            <div
              key={n.id}
              style={{
                padding: "12px 14px",
                background: n.read_at ? "var(--surface-2)" : "var(--primary-50)",
                border: "1px solid var(--border)",
                borderRadius: 8,
                display: "flex",
                gap: 10,
                cursor: "pointer",
              }}
              onClick={() => !n.read_at && onMarkRead?.(n.id)}
            >
              <div
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 999,
                  background: "var(--primary-100)",
                  color: "var(--primary-700)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <Icon name="bell" size={14} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="t-primary text-sm fw-500">{n.data?.title || "Notification"}</div>
                <div className="t-muted text-xs" style={{ marginTop: 2 }}>{n.data?.message}</div>
                <div className="t-muted text-xs" style={{ marginTop: 4 }}>{fromNow(n.created_at)}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Drawer>
  );
}
